module.exports = __webpack_public_path__ + "img/CHUVASH.92afb248.png";